import { render, staticRenderFns } from "./CalendarGrid.vue?vue&type=template&id=4532971e&scoped=true&"
import script from "./CalendarGrid.vue?vue&type=script&lang=js&"
export * from "./CalendarGrid.vue?vue&type=script&lang=js&"
import style0 from "./CalendarGrid.vue?vue&type=style&index=0&id=4532971e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532971e",
  null
  
)

export default component.exports